import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import styles from "./Login.module.css";
import { useNavigate } from "react-router-dom";
import LoginQuery from "../../queries/User/Login";
import EditUserQuery from "../../queries/User/EditUser";
import withReactContent from "sweetalert2-react-content";
import swal from "sweetalert2";
import Button from "react-bootstrap/Button";
import { Modal, ModalBody, ModalHeader, Form } from "react-bootstrap";
import { useSelector } from "react-redux";

export default function Login() {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [showError, setShowError] = useState(false);
    const [errorMessage, setErrormessage] = useState("");
    const [userData, setUserData] = useState();
    const [showModal, setShowModal] = useState(false);
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [newPassword, setNewPassword] = useState();
    const [verifyNewPassword, setVerifyNewPassword] = useState();
    const userAddMessage = withReactContent(swal);
    const [editIsLoading, setEditIsLoading] = useState(false);
    const nutitee = useSelector((state) => state.nutitee.value);

    const handleModalClose = () => setShowModal(false);
    const handleModalShow = () => setShowModal(true);

    const handleNewPasswordChange = (e) => {
        setNewPassword(e.target.value);
    };
    
    const handleVerifyNewPasswordChange = (e) => {
        setVerifyNewPassword(e.target.value);
    };

    useEffect(() => {
        if (localStorage.getItem("bearer-token") && localStorage.getItem("me")) {
            navigate("/");
        }
    }, [navigate]);

    const doLogin = async () => {
        setErrormessage("");
        setShowError(false);

        setIsLoading(true);
        if (email.trim().length < 2 || password.trim().length < 2) {
            setShowError(true);
            setErrormessage("Please enter valid credentials");
            setIsLoading(false);
            return;
        }

        try {
            let result = await LoginQuery(email, password);

            if (result.status !== 200) {
                setShowError(true);
                setErrormessage(result.response?.data?.message || "Login failed");
                setIsLoading(false);
                return;
            }

            let data = result.data.data;

            if (data.user.groups.length < 1) {
                setShowError(true);
                setErrormessage("User does not belong to any group!");
                setIsLoading(false);
                return;
            }

            localStorage.setItem("bearer-token", data.access_token);
            localStorage.setItem("me", JSON.stringify(data.user));
            localStorage.setItem("current_group", JSON.stringify(data.user.groups[0]));

            setIsLoading(false);
            setUserData(JSON.parse(localStorage.getItem("me")));

            if (data.user.init_password === 1) {
                handleModalShow();
            } else {
                navigate("/");
            }
        } catch (error) {
            setShowError(true);
            setErrormessage("Login failed");
            setIsLoading(false);
        }
    };

    const handleEmailChange = (e) => {
        setEmail(e.target.value);
    };

    const handlePasswordChange = (e) => {
        setPassword(e.target.value);
    };

    const handleForgotPassword = () => {
        userAddMessage.fire({
            title: <strong>Forgot Password</strong>,
            html: <i>Please contact your administrator to reset your password.</i>,
            icon: "info",
        });
    };

    const savePassword = () => {
        setEditIsLoading(true);

        let errMessage;

        if (newPassword !== verifyNewPassword) {
            errMessage = "Passwords don't match";
            userAddMessage
                .fire({
                    title: <strong>{t("Error")}</strong>, 
                    html: <i>{t(errMessage)}</i>, 
                    icon: "error",
                })
                .then();
            setEditIsLoading(false);
        } else if (!newPassword) {
            errMessage = "Password field is empty";
            userAddMessage
                .fire({
                    title: <strong>{t("Error")}</strong>, 
                    html: <i>{t(errMessage)}</i>, 
                    icon: "error",
                })
                .then();
            setEditIsLoading(false);
        } else {
            let sg = [];
            for (const [, value] of Object.entries(userData.groups)) {
                sg.push(value.id);
            }

            EditUserQuery(
                userData.id, 
                userData.email, 
                userData.first_name, 
                userData.last_name, 
                password, 
                newPassword, 
                userData.description, 
                sg
            ).then((response) => {
                handleServerResponse(response);
            });
            return;
        }
    };

    const handleServerResponse = (response) => {
        if (response.status !== 200 && response.status !== 201) {
            let message = response.response.data?.message;

            if (message === "Validation error") {
                let data = response.response.data.data;
                message = "";

                for (const [, value] of Object.entries(data)) {
                    message = message + value[0] + "<br/>";
                }
            }

            setEditIsLoading(false);

            userAddMessage
                .fire({
                    title: <strong>{t("Error")}</strong>, 
                    html: message, 
                    icon: "error",
                })
                .then();

            return;
        }

        setEditIsLoading(false);

        userAddMessage
            .fire({
                title: <strong>{t("Settings changed")}</strong>, 
                icon: "success", 
                showConfirmButton: false, 
                timer: 2000,
            })
            .then(() => {
                handleModalClose();
                navigate("/");
            });
    };

    return (
        <>
            <div 
                className={styles.loginContainer}
                style={{
                    backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.45), rgba(0, 0, 0, 0.45)), url(${process.env.PUBLIC_URL}/bg.jpg)`
                }}
                
            >
                       
                <div className={styles.loginCard}>
                    <div className={styles.cardHeader}>
                        <div className={styles.logoBox}>
                            <svg viewBox="0 0 24 24" fill="currentColor">
                                <path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM12 17c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zM9 6c0-1.66 1.34-3 3-3s3 1.34 3 3v2H9V6z"/>
                            </svg>
                        </div>
                        <h1>Bercman Mobility</h1>
                        <p className={styles.subtitle}>Control Hub</p>
                        <p>Sign in to continue</p>
                    </div>

                    {showError && (
                        <div className={styles.errorText}>
                            {errorMessage}
                        </div>
                    )}

                    <form className={styles.loginForm} onSubmit={(e) => { e.preventDefault(); doLogin(); }}>
                        <div className={styles.inputGroupCustom}>
                            <label htmlFor="email">Email</label>
                            <div className={styles.inputWrapper}>
                                <svg className={styles.inputIcon} viewBox="0 0 24 24" fill="currentColor">
                                    <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
                                </svg>
                                <input
                                    type="text"
                                    id="email"
                                    placeholder="email@example.com"
                                    value={email}
                                    autoFocus={true}
                                    onChange={handleEmailChange}
                                />
                            </div>
                        </div>

                        <div className={styles.inputGroupCustom}>
                            <label htmlFor="userpassword">Password</label>
                            <div className={styles.inputWrapper}>
                                <svg className={styles.inputIcon} viewBox="0 0 24 24" fill="currentColor">
                                    <path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM9 6c0-1.66 1.34-3 3-3s3 1.34 3 3v2H9V6z"/>
                                </svg>
                                <input
                                    type="password"
                                    id="userpassword"
                                    placeholder="Password"
                                    autoComplete="on"
                                    value={password}
                                    onChange={handlePasswordChange}
                                />
                            </div>
                        </div>

                        <button 
                            type="submit" 
                            className={styles.loginBtn}
                            disabled={isLoading}
                        >
                            {isLoading ? (
                                <div className={styles.spinner}></div>
                            ) : (
                                'Sign In'
                            )}
                        </button>
                    </form>
                </div>
            </div>

            <Modal
                className="init-pw-change-modal"
                show={showModal}
                centered={true}
                backdrop="static"
                keyboard={false}
            >
                <ModalHeader>
                    <Modal.Title>Choose new password</Modal.Title>
                </ModalHeader>
                <ModalBody>
                    <Form.Group className="mb-3">
                        <Form.Control
                            type="password"
                            placeholder={t("New password")}
                            onChange={handleNewPasswordChange}
                        />
                        <Form.Control
                            type="password"
                            placeholder={t("Repeat new password")}
                            onChange={handleVerifyNewPasswordChange}
                            style={{ marginTop: "10px" }}
                        />
                    </Form.Group>
                </ModalBody>
                <Modal.Footer>
                    <Button
                        variant="primary"
                        onClick={() => savePassword()}
                        disabled={editIsLoading}
                    >
                        {editIsLoading ? (
                            <div className={styles.spinner}></div>
                        ) : (
                            t("Save")
                        )}
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}